import { getIsUngatedByForceSeatsPricingParam } from 'pricing-pages-lib/utils/gatingUtils';
import { useIsUngatedForSeats } from '../v2/hooks/gating/useIsUngated';
export const useShouldHideDataOrSuitePage = () => {
  const {
    isUngatedForSeats,
    loading
  } = useIsUngatedForSeats();
  if (loading) {
    return false;
  }
  const isUngated = getIsUngatedByForceSeatsPricingParam() || isUngatedForSeats;
  return !isUngated;
};